import React from 'react';
import { PiButton, PiPaper } from '@sensei/pi-component';
import { OptInDeviceType } from '../../../types/opt-in-device.type';
import useAddYourDeviceStyles from '../../../styles/opt-in/add-your-device.style';
import { useTranslation } from 'react-i18next';

type AddYourDeviceConfirmationDialogProps = {
    status: boolean;
    device: OptInDeviceType;
    onFinishClick: () => void;
    onTryAgainClick: () => void;
};

export function AddYourDeviceConfirmationDialog(
    props: AddYourDeviceConfirmationDialogProps,
) {
    const classes = useAddYourDeviceStyles();
    const { t } = useTranslation();
    const getButton = () => {
        if (props.status) {
            return (
                <PiButton
                    fullWidth
                    color="primary"
                    className={classes.dialogButton}
                    onClick={() => props.onFinishClick()}
                >
                    {t('addYourDeviceDialog.finish')}
                </PiButton>
            );
        } else {
            return (
                <PiButton
                    fullWidth
                    color="primary"
                    className={classes.dialogButton}
                    onClick={() => props.onTryAgainClick()}
                >
                    {t('addYourDeviceDialog.tryAgain')}
                </PiButton>
            );
        }
    };
    return (
        <>
            <PiPaper className={classes.dialogPaper}>
                <div className={classes.dialogPaperContent}>
                    <img
                        src={`/static/images/` + props.device.logoFileName}
                        className={classes.dialogPaperLogo}
                        alt={props.device.description}
                    />
                </div>
                {getButton()}
            </PiPaper>
        </>
    );
}
